export const profileTypesToTargets = {
    prompts_docs_llm: ["api_target", "llm_model_target"],
    ai_model_attack_surface: ["llm_model_target"],
    mcp_tester: ["mcp_target"],
    dos_tester: ["api_target", "llm_model_target"],
    rto: ["api_target", "llm_model_target"],
    regulation_compliance: ["api_target", "llm_model_target"],
};

export const targetsToProfileTypes = {
    api_target: ["prompts_docs_llm", "dos_tester", "rto", "regulation_compliance"],
    llm_model_target: [
        "prompts_docs_llm",
        "dos_tester",
        "rto",
        "regulation_compliance",
        "ai_model_attack_surface",
    ],
    mcp_target: ["mcp_tester"],
};

/** Allowed target types for a profile type. */
export function getAllowedTargetTypes(profileType) {
    return profileTypesToTargets[profileType] || [];
}
